import React from 'react';

import { useAnswerPreview } from '../../../../../../hooks/answers/useAnswerPreview';
import { AnswerChatCard } from '../../../../../Answers/Answer/AnswerChatCard';
import { AnswersListMore } from '../../../../../Answers/List/More/AnswersListMore';
import { INTERNAL_SEARCH_TOOL_CALL_NAME } from '../../ToolCall/InternalSearchToolCall/consts';
import { ExtendedAnswer } from '../types';

import styles from './InternalToolCallResults.module.scss';

const MAX_ITEMS_TO_DISPLAY = 10;

export interface InternalToolCallResultsProps {
    functionName: typeof INTERNAL_SEARCH_TOOL_CALL_NAME;
    data: ExtendedAnswer[];
}

export const InternalToolCallResults: React.FC<InternalToolCallResultsProps> = ({ data }) => {
    const hasMore = data.length > MAX_ITEMS_TO_DISPLAY;
    const [collapsed, setCollapsed] = React.useState(hasMore);

    const openAnswerPreview = useAnswerPreview();

    const showCount = collapsed ? MAX_ITEMS_TO_DISPLAY : data.length;

    return (
        <>
            {data.slice(0, showCount).map((answer) => (
                <AnswerChatCard key={answer.doc_id} answer={answer} onClick={openAnswerPreview} />
            ))}
            {hasMore && (
                <AnswersListMore
                    className={styles.showMore}
                    collapsed={collapsed}
                    onToggleCollapse={() => setCollapsed((prev) => !prev)}
                />
            )}
        </>
    );
};
